export default __webpack_public_path__ + "static/media/profile11.ed1cb5bd.png";